<template>
  <tbody>
    <tr class="more_bg1">
      <td class="mo_rbg_1">
        <div id="show_Info" class="more_div">
          <!---------- GAME 3 ---------->
          <table id="model_GAME3" border="0" cellpadding="0" cellspacing="0">
            <tbody>
              <tr class="more_bg1_tn">
                <td class="more_tn_td" colspan="2">
                  <span class="mbk_ytitle">3rd Set</span>
                  <template v-if="eventAllBet.ha == 'N'">
                    <img :src="'assets/images/more_n_'+ langSelected +'.jpg'" class="more_n">
                  </template>
                </td>
                <td class="tn_w">1</td>
                <td class="tn_w">2</td>
                <td class="tn_w">3</td>
                <td class="tn_point">{{ sportAllBetLang['ALL_BET.LBL_POINT'] }}</td>
                <td class="tn_pw">{{ sportAllBetLang['ALL_BET.LBL_SET'] }}</td>
                <td class="tn_total" v-html="sportAllBetLang['ALL_BET.LBL_TOTAL_GAMES']"></td>
              </tr>
              <tr class="more_bg2_tn">
                <td class="mtnr_dot_w">
                  <span class="more_dot_out" ></span>
                </td>
                <td class="mtn_title">
                  <span class="mtnr_team" v-html="eventAllBet.tacapt"></span>
                </td>
                <td>3</td>
                <td>7</td>
                <td class="tn_color">3</td>
                <td class="more_tn_h">0</td>
                <td class="more_tn_h">1</td>
                <td class="more_tn_h">13</td>
              </tr>
              <tr class="more_bg2_tn">
                <td><span class="more_dot_on"></span></td>
                <td class="mtn_title">
                  <span class="mtnr_team" v-html="eventAllBet.tbcapt"></span>
                </td>
                <td>6</td>
                <td>6</td>
                <td class="tn_color">3</td>
                <td class="more_tn_h">30</td>
                <td class="more_tn_h">1</td>
                <td class="more_tn_h">15</td>
              </tr>
            </tbody>
          </table>
          <!---------- GAME 3 ---------->
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
  import DateFilter from '@/vue/filters/date'
  import {
    mapGetters
  } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'eventAllBet',
        'sportAllBetLang',
        'eventAllBet',
      ]),
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-team-info-tn.vue